import {useState} from 'react';
import {StyleSheet, Image, View} from 'react-native';
import {useImagePreload} from 'interface/hooks/useImagePreload';

export interface FileImageProps {
  large?: boolean,
  size?: 'small' | 'medium' | 'large',
  source?: string,
  onError?: () => void,
}

export function FileImage(props: FileImageProps) {
  const [loaded, setLoaded] = useState(false);
  const image = useImagePreload(props.source);
  
  // Determine which size to use
  // When no size is specified, don't apply any size styles (for list views)
  const size = props.size || (props.large ? 'large' : undefined);
  
  const classes = {
    root: [
      styles.root,
      size === 'small' && styles.small,
      size === 'medium' && styles.medium,
      size === 'large' && styles.large,
    ],
    image: [
      styles.image,
      loaded && styles.loaded,
      size === 'small' && styles.imageSmall,
      size === 'medium' && styles.imageMedium,
      size === 'large' && styles.imageLarge,
    ],
  };

  return (
    <View style={classes.root}>
      {!!image &&
        <Image
          style={classes.image}
          source={{uri: image}}
          onError={props.onError}
          onLoad={() => setLoaded(true)}
          resizeMode="contain"
        />
      }
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 38,
    flex: 1,
  },
  small: {
    width: 60,
    height: 60,
  },
  medium: {
    width: 100,
    height: 100,
  },
  large: {
    width: 190,
    height: 190,
  },
  image: {
    width: 32,
    height: 38,
    opacity: 0,
    // transition: '.2s opacity', TODO: WEB ONLY
    position: 'relative',
  },
  imageSmall: {
    width: 60,
    height: 60,
  },
  imageMedium: {
    width: 100,
    height: 100,
  },
  imageLarge: {
    width: 190,
    height: 190,
  },
  loaded: {
    opacity: 1,
  }
});
